import { unref as _unref, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-497884aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src", "poster", "autoplay", "controls", "loop", "muted", "preload", "onClickOnce"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.25 12L9.75 8.75V15.25L15.25 12Z"
}, null, -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
import { ref, onMounted } from 'vue';
// window.screen.orientation.lock("portrait-secondary");

export default {
  __name: 'Video',
  props: {
    src: {
      // 视频文件url，必传，支持网络地址 https 和相对地址 require('@/assets/files/Bao.mp4')
      type: String,
      required: true,
      default: ''
    },
    poster: {
      // 视频封面url，支持网络地址 https 和相对地址 require('@/assets/images/Bao.jpg')
      type: String,
      default: ''
    },
    second: {
      // 在未设置封面时，自动截取视频第 second 秒对应帧作为视频封面
      type: Number,
      default: 0.5
    },
    width: {
      // 视频播放器宽度
      type: String,
      default: '800px'
    },
    height: {
      // 视频播放器高度
      type: String,
      default: '450px'
    },
    autoplay: {
      // 视频就绪后是否马上播放
      type: Boolean,
      default: false
    },
    controls: {
      // 是否向用户显示控件，比如进度条，全屏
      type: Boolean,
      default: true
    },
    loop: {
      // 视频播放完成后，是否循环播放
      type: Boolean,
      default: false
    },
    muted: {
      // 是否静音
      type: Boolean,
      default: false
    },
    preload: {
      // 是否在页面加载后载入视频，如果设置了autoplay属性，则preload将被忽略；
      type: String,
      default: 'auto' // auto:一旦页面加载，则开始加载视频; metadata:当页面加载后仅加载视频的元数据 none:页面加载后不应加载视频
    },

    showPlay: {
      // 播放暂停时是否显示播放器中间的暂停图标
      type: Boolean,
      default: true
    },
    playWidth: {
      // 中间播放暂停按钮的边长
      type: Number,
      default: 96
    },
    zoom: {
      // video的poster默认图片和视频内容缩放规则
      type: String,
      default: 'contain' // none:(默认)保存原有内容，不进行缩放; fill:不保持原有比例，内容拉伸填充整个内容容器; contain:保存原有比例，内容以包含方式缩放; cover:保存原有比例，内容以覆盖方式缩放
    }
  },

  emits: ['onPlaying'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    let originPlay = ref(true);
    let hidden = ref(false);
    let veoPoster = ref(props.poster);
    const veo = ref(null);
    const getPoster = function () {
      // 在未设置封面时，自动获取视频0.5s对应帧作为视频封面
      // 由于不少视频第一帧为黑屏，故设置视频开始播放时间为0.5s，即取该时刻帧作为封面图

      veo.value.currentTime = props.second;
      // 创建canvas元素
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // canvas画图
      canvas.width = veo.value.videoWidth;
      canvas.height = veo.value.videoHeight;
      ctx.drawImage(veo.value, 0, 0, canvas.width, canvas.height);
      // 把canvas转成base64编码格式
      veoPoster.value = canvas.toDataURL('image/png');
    };
    function onPlay() {
      if (originPlay.value) {
        veo.value.currentTime = 0;
        originPlay.value = false;
      }
      if (props.autoplay) {
        var _veo$value;
        (_veo$value = veo.value) === null || _veo$value === void 0 ? void 0 : _veo$value.pause();
      } else {
        var _veo$value2;
        hidden.value = true;
        (_veo$value2 = veo.value) === null || _veo$value2 === void 0 ? void 0 : _veo$value2.play();
      }
    }
    function onPause() {
      hidden.value = false;
    }
    function onPlaying() {
      emit('onPlaying', 1);
      hidden.value = true;
    }
    function videoPause() {
      veo.value.pause();
    }
    function onFullscreenChange() {
      console.log('ch');
      window.screen.orientation.lock("landscape-secondary");
    }
    onMounted(() => {
      hidden.value = true;
      originPlay.value = false;
      window.screen.orientation.addEventListener('change', function () {
        window.screen.orientation.lock("portrait-secondary");
      });
    });
    __expose({
      videoPause
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["m-video", {
          'u-video-hover': !_unref(hidden)
        }]),
        style: _normalizeStyle(`width: ${__props.width}; height: ${__props.height};`)
      }, [_createElementVNode("video", _mergeProps({
        ref_key: "veo",
        ref: veo,
        style: `object-fit: ${__props.zoom}; width: ${__props.width}; height: ${__props.height};`,
        src: __props.src,
        poster: _unref(veoPoster),
        autoplay: __props.autoplay,
        controls: !_unref(originPlay) && __props.controls,
        loop: __props.loop,
        muted: __props.autoplay || __props.muted,
        preload: __props.preload,
        crossorigin: "anonymous",
        onLoadeddata: _cache[0] || (_cache[0] = $event => __props.poster ? () => false : getPoster()),
        onPause: _cache[1] || (_cache[1] = $event => __props.showPlay ? onPause() : () => false),
        onPlaying: _cache[2] || (_cache[2] = $event => __props.showPlay ? onPlaying() : () => false),
        onClickOnce: _withModifiers(onPlay, ["prevent"])
      }, _ctx.$attrs, {
        onFullscreenchange: onFullscreenChange,
        onWebkitfullscreenchange: onFullscreenChange
      }), " 您的浏览器不支持video标签。 ", 16, _hoisted_1), _withDirectives((_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["u-play", {
          'hidden': _unref(hidden)
        }]),
        style: _normalizeStyle(`width: ${__props.playWidth}px; height: ${__props.playWidth}px;`),
        viewBox: "0 0 24 24"
      }, _hoisted_4, 6)), [[_vShow, _unref(originPlay) || __props.showPlay]])], 6);
    };
  }
};